import React from 'react';
import { IconName } from './types';
import classNames from 'classnames';
interface Props {
    icon: IconName;
    className?: string;
}

const Icon = ({ icon, className }: Props) =>
    <span className={classNames('glyphicon', `glyphicon-${icon}`, className)} />;

export default Icon;
